'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _privateRoute = require('./private.route');

var _privateRoute2 = _interopRequireDefault(_privateRoute);

var _privateLocale = require('./private.locale');

var _privateLocale2 = _interopRequireDefault(_privateLocale);

require('./administrators');
require('./agents');
require('./buses');
require('./change-password');
require('./cities');
require('./currencies');
require('./discounts');
require('./lines');
require('./offices');
require('./prices');
require('./promotions');
require('./reports');
require('./sales');
require('./seats');
require('./stations');
require('./tickets');
require('./waybill');
require('./negotiated-seats');

angular.module('BTMS').config(_privateRoute2['default']).config(_privateLocale2['default']);


/** WEBPACK FOOTER **
 ** ./client/private/index.js
 **/